import React from 'react';

import { Svg, Path } from './styled';

const Icon = ({ className, innerRef, fill }) => {
    const pathDefinitions = [
        'M7.58594 7.21875C7.2207 7.69336 6.64648 8 6 8C5.54883 8 5.13281 7.85156 4.79688 7.59961C4.3125 7.23438 4 6.6543 4 6C4 4.89453 4.89453 4 6 4C7.10547 4 8 4.89453 8 6C8 6.45898 7.8457 6.88281 7.58594 7.21875Z',
        'M13.5859 7.21875C13.2207 7.69336 12.6465 8 12 8C11.5488 8 11.1328 7.85156 10.7969 7.59961C10.3125 7.23438 10 6.6543 10 6C10 4.89453 10.8945 4 12 4C13.1055 4 14 4.89453 14 6C14 6.45898 13.8457 6.88281 13.5859 7.21875Z',
        'M19.5859 7.21875C19.2207 7.69336 18.6465 8 18 8C17.5488 8 17.1328 7.85156 16.7969 7.59961C16.3125 7.23438 16 6.6543 16 6C16 4.89453 16.8945 4 18 4C19.1055 4 20 4.89453 20 6C20 6.45898 19.8457 6.88281 19.5859 7.21875Z',
        'M8 12C8 13.1055 7.10547 14 6 14C4.89453 14 4 13.1055 4 12C4 10.8945 4.89453 10 6 10C6.64062 10 7.21094 10.3008 7.57617 10.7695C7.8418 11.1094 8 11.5352 8 12Z',
        'M14 12C14 13.1055 13.1055 14 12 14C10.8945 14 10 13.1055 10 12C10 10.8945 10.8945 10 12 10C12.6406 10 13.2109 10.3008 13.5762 10.7695C13.8418 11.1094 14 11.5352 14 12Z',
        'M20 12C20 13.1055 19.1055 14 18 14C16.8945 14 16 13.1055 16 12C16 10.8945 16.8945 10 18 10C18.6406 10 19.2109 10.3008 19.5762 10.7695C19.8418 11.1094 20 11.5352 20 12Z',
        'M7.70117 19.0527C7.89062 18.748 8 18.3867 8 18C8 16.8945 7.10547 16 6 16C4.89453 16 4 16.8945 4 18C4 19.1055 4.89453 20 6 20C6.71875 20 7.34961 19.6211 7.70117 19.0527Z',
        'M13.7012 19.0527C13.8906 18.748 14 18.3867 14 18C14 16.8945 13.1055 16 12 16C10.8945 16 10 16.8945 10 18C10 19.1055 10.8945 20 12 20C12.7188 20 13.3496 19.6211 13.7012 19.0527Z',
        'M19.7012 19.0527C19.8906 18.748 20 18.3867 20 18C20 16.8945 19.1055 16 18 16C16.8945 16 16 16.8945 16 18C16 19.1055 16.8945 20 18 20C18.7188 20 19.3496 19.6211 19.7012 19.0527Z',
    ];

    const renderPath = (pathDefinition) => (
        <Path key={pathDefinition} className="ball" d={pathDefinition} fill={fill} />
    );
    return (
        <Svg
            ref={innerRef}
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {pathDefinitions.map(renderPath)}
        </Svg>
    );
};

export default Icon;
